import { prop } from "fw";
import { Form } from "fw-model";

export class Validation {
    @prop(null) private form!: Form;
    @prop(false) private showFieldMessages!: boolean;
}
